import React, { Component } from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, Button, Row,  Nav, NavItem, NavLink } from 'reactstrap';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import { AppHeaderDropdown, AppNavbarBrand } from '@coreui/react';
import logo from '../../assets/img/title-blue.png';
import {
    AppHeader,
  } from '@coreui/react';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class LogoHeader extends Component {

    constructor(props) {
        super(props);
        this.state = {
            login: false,
            signup: false,
            warning: "",
            showVerify: false,
            html_btn_status: 0,
        };
        this.user_name = "";
        this.pwd = "";
        this.toggleLogin = this.toggleLogin.bind(this);
        this.toggleRegister = this.toggleRegister.bind(this);
    }

    toggleLogin() {
      let userId = localStorage.getItem('user_id');
      if (userId !== null) {
        window.location = "/dashboard";
      } else {
        this.setState({login: true});
      }
    }
    toggleRegister() {
    this.setState({signup: true});
    }
    renderRedirect = () => {
    if (this.state.login) {
        return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
        return <Redirect to= { '/register/'} />
    }
    }

  render() {

    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
        <AppHeader className="min-width-1124" fixed>
        {this.renderRedirect()}
        <Row className = "home-padding-left d-md-down-none"></Row>
        <AppNavbarBrand
            href="/"
            className ="home-nav-bar d-md-down-none "
            full={{ src: logo, width: 103, height: 30, alt: 'AbilitàXR Logo' }}
        /> 
        <AppNavbarBrand
            href="/"
            className ="d-lg-none"
            full={{ src: logo, width: 103, height: 30, alt: 'AbilitàXR Logo' }}
        />   
        <Nav className="d-md-down-none" navbar>
          <NavItem className="px-3 header-padding">
            <NavLink className="header-padding-left-0" href="/">Home</NavLink>
          </NavItem>
          <NavItem className="px-3 header-padding">
            <NavLink className="header-padding-left-0" href="/about">About Us</NavLink>
          </NavItem>
          <NavItem className="px-3 header-padding">
            <NavLink className="header-padding-left-0" href="/contact">Contact</NavLink>
          </NavItem>
          <NavItem className="px-3 header-padding">
            <NavLink className="header-padding-left-0" href="/faq">FAQ</NavLink>
          </NavItem>
        </Nav>

        <Nav className="ml-auto mr-3 " navbar>
          <NavItem className="d-md-down-none">
            <NavLink className = "point-hand" onClick = {()=> this.toggleLogin()}>Login</NavLink>
          </NavItem>
          <NavItem className="d-md-down-none mr-5">
            <NavLink href="/register/" >
              <Button color = "primary" className="pr-4 mr-3 pl-4 btn-pill btn btn-primary home-primary-btn" >Sign up for Free</Button>
            </NavLink>
          </NavItem>
          <AppHeaderDropdown className="d-lg-none" direction="down">
            <DropdownToggle nav>
              <span className="navbar-toggler-icon"></span>
            </DropdownToggle>
            <DropdownMenu right style={{ right: 'auto' }}>
              <DropdownItem onClick = {()=> this.toggleLogin()}> Login </DropdownItem>
              <DropdownItem onClick = {()=> this.toggleRegister()}> Sign up for Free </DropdownItem>
            </DropdownMenu>
          </AppHeaderDropdown>
        </Nav>
        <Row className = "home-padding-right d-md-down-none"></Row>
      </AppHeader>
    );
  }
}

LogoHeader.propTypes = propTypes;
LogoHeader.defaultProps = defaultProps;

export default LogoHeader;



// WEBPACK FOOTER //
// ./src/containers/Components/LogoHeader.js